<template>
  <div>
    <div class="breadcrumbs">
      <div class="container">
          <div class="breadcrumbs__list">
              <router-link to="/" class="breadcrumbs__item">Home</router-link>
              <div class="breadcrumbs__item breadcrumbs__item--active">Help</div>
          </div>
      </div>
    </div>
      <a id="home" name="home"></a>
    <div class="help">
        <div class="container">
            <div class="help__head">
                <h2 class="help__title">We are glad to help you</h2>
                <p class="help__desc">Browse through the most frequently asked questions.</p>
            </div>
        </div>
        <div class="help__body">
            <div class="container">
                <div class="help__body__inner">
                    <div class="help__item" v-for="item in items" :key="item.date"
                         v-bind:id="'help_item_body_' + item.id">
                        <h3 class="help__item__title" @click="openItem(item.id)">{{ item.title.rendered }}</h3>
                        <div class="help__item__body">
                            <p class="help__item__text" v-html="item.content.rendered"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <a name="contact" id="contact"></a>
    <div class="help-form">
        <div class="container">
            <div class="help-form__body">
                <h2 class="help-form__title">Can’t find what you’re looking for?</h2>
                <p class="help-form__desc">Get immediate answer by submitting the form below</p>
                <form class="help-form__main" @submit.prevent="sendQuestion()">
                    <div class="help-form__main__block">
                        <input type="text" v-model="question.name" class="input-default" placeholder="Full name">
                    </div>
                    <div class="help-form__main__block">
                        <input type="email" v-model="question.email" class="input-default" placeholder="Email address">
                    </div>
                    <div class="help-form__main__block help-form__main__block--fullw">
                        <textarea v-model="question.question" class="input-default" rows="8" placeholder="Your question"></textarea>
                    </div>
                    <div class="help-form__main__controls">
                        <button type="submit" class="button button--secondary">SUBMIT</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import wp from '@/utils/wp'
import $ from 'jquery'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'Help',
  data () {
    return {
      items: [],
      question: {
        email: '',
        name: '',
        question: ''
      }
    }
  },
  head: {
    title: {
      inner: 'Help',
      separator: '-',
      complement: 'Ad Operator'
    },
    meta: [
      {
        name: 'description',
        content: 'Help page Ad Operator'
      },
      {
        name: 'keywords',
        content: 'help'
      },
      {
        property: 'og:title',
        content: 'Help - Ad Operator'
      },
      {
        property: 'og:image',
        content: 'https://adop.co/static/favicon/android-icon-192x192.png'
      },
      {
        property: 'og:url',
        content: 'https://adop.co/help'
      },
      {
        property: 'og:description',
        content: 'Help page Ad Operator'
      }
    ],
    link: [
      {
        rel: 'canonical',
        h: 'https://adop.co/help',
        id: 'canonical'
      }
    ]
  },
  methods: {
    sendQuestion: function () {
      axios.get('https://adop.co/api/question?email=' + this.question.email + '&name=' + this.question.name + '&question=' + this.question.question)
        .then(resp => {
          Swal('Success', 'You question sendet', 'success')
        })
        .catch(error => {
          console.log(error)
        })
    },
    openItem: function (id) {
      if (!$('#help_item_body_' + id).hasClass('help__item--active')) {
        $('#help_item_body_' + id).addClass('help__item--active').siblings().removeClass('help__item--active')
      } else {
        $('#help_item_body_' + id).removeClass('help__item--active')
      }
    }
  },
  mounted () {
    // window.$('html,body').scrollTop(window.$('#home').offset().top)
    wp({type: 'posts', data: {categories: 3, per_page: 15}})
      .then(resp => {
        this.items = resp
        if (this.$route.fullPath === '/help/#contact') {
          // window.$('html,body').scrollTop(window.$('#contact').offset().top)
          setTimeout(function () {
            $('body,html').animate({scrollTop: $('#contact').offset().top}, 200)
          }, 200)
        }
      })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/front/help.vue